import {
  ConcreteShortName,
  ConcretePlacementDate,
  ConcretePlacementId,
  ConcreteFieldNumber,
  ConcreteTestSubId,
  ConcreteFieldNumbers,
  ConcreteTestSubIds,
  ConcretePlacementIds,
} from '../../filenameTemplateItems/instances/concrete'
import {
  concretes,
  projects,
} from '../../filenameTemplateItems/instances/groups'
import { SimpleReportItem } from '../classes/SimpleReportItem'
import {
  ConcreteTestSetPacketReportItem,
  ConcreteTestSetReportItem,
} from '../classes/concrete'

export const ConcretePlacementCoreSheet = new SimpleReportItem({
  id: '3cea284e-d128-4d27-8d26-2627f6d4416a',
  name: 'Concrete Placement and Core Sheet',
  classType: 'ConcretePlacement',
  classTypeName: 'Concrete Placement',
  endpoint: 'concretePlacements',
  queryParameter: 'placement-core-sheet',
  label: 'placementId',
  sampleFilename: 'concrete-placement-and-core-sheet',
  afterClientProjectNumber: [
    { type: 'templateItem', templateItemId: ConcreteShortName.id },
    { type: 'custom', text: '_THICKNESS_' },
    { type: 'templateItem', templateItemId: ConcretePlacementDate.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: ConcretePlacementId.id },
  ],
  compatibleTemplateItems: [ConcretePlacementId, ...projects, ...concretes],
  key: 'globalId',
})

export const ConcreteCylinderIASheet = new SimpleReportItem({
  id: '7e4a502f-3aa6-46d0-8435-24465ff61964',
  name: 'Concrete Cylinder and IA Sheet',
  classType: 'ConcreteTest',
  classTypeName: 'Concrete Test',
  endpoint: 'concreteTests',
  queryParameter: 'cylinder-ia-sheet',
  label: 'fieldNumber',
  sampleFilename: 'concrete-cylinder-and-ia-sheet',
  afterClientProjectNumber: [
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: ConcreteShortName.id },
    { type: 'custom', text: '_CONCRETE-STRENGTH-RPT_' },
    { type: 'templateItem', templateItemId: ConcretePlacementDate.id },
    { type: 'custom', text: '_' },
    { type: 'templateItem', templateItemId: ConcreteFieldNumber.id },
  ],
  compatibleTemplateItems: [
    ConcreteFieldNumber,
    ConcreteTestSubId,
    ...projects,
    ...concretes,
  ],
  key: 'globalId',
})

export const ConcreteTestSet = new ConcreteTestSetPacketReportItem(
  '3b3a3626-33ec-4cad-833b-ba606c0496ea'
)

export const ConcreteTestSetCylinders = new ConcreteTestSetReportItem({
  id: '29e3386c-efea-4fdd-ab6c-199b8c0302dd',
  name: 'Concrete Cylinder and IA Sheet by Concrete Test Set',
  queryParameter: 'cylinder-ia-sheet',
  sampleFilename: 'concrete-cylinder-and-ia-sheet',
  description: 'CONCRETE-STRENGTH-RPT',
  defaultTemplateItem: ConcreteFieldNumbers,
  additionalCompatibleTemplateItems: [ConcreteFieldNumbers, ConcreteTestSubIds],
})

export const ConcreteTestSetPlacements = new ConcreteTestSetReportItem({
  id: '0abd65b6-5d78-4fa2-a30b-f5d01142c6af',
  name: 'Concrete Placement and Core Sheet by Concrete Test Set',
  queryParameter: 'placement-core-sheet',
  sampleFilename: 'concrete-placement-and-core-sheet',
  description: 'THICKNESS',
  defaultTemplateItem: ConcretePlacementIds,
  additionalCompatibleTemplateItems: [ConcretePlacementIds],
})

export type ConcreteReportItem =
  | typeof ConcretePlacementCoreSheet
  | typeof ConcreteCylinderIASheet
  | typeof ConcreteTestSet
  | typeof ConcreteTestSetCylinders
  | typeof ConcreteTestSetPlacements
